import createIcon from '../../createIcon';

/**
 * @component @name Brightness6
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBjbGlwLXBhdGg9InVybCgjY2xpcDBfMjQwMl8yMzU0MCkiPgo8cGF0aCBkPSJNMjAuMDAwNCAxNS4zMDk1TDIzLjMxMDQgMTEuOTk5NUwyMC4wMDA0IDguNjg5NDVWMy45OTk0NUgxNS4zMTA0TDEyLjAwMDQgMC42ODk0NTNMOC42OTA0MyAzLjk5OTQ1SDQuMDAwNDNWOC42ODk0NUwwLjY5MDQzIDExLjk5OTVMNC4wMDA0MyAxNS4zMDk1VjE5Ljk5OTVIOC42OTA0M0wxMi4wMDA0IDIzLjMwOTVMMTUuMzEwNCAxOS45OTk1SDIwLjAwMDRWMTUuMzA5NVpNMTIuMDAwNCAxNy45OTk1VjUuOTk5NDVDMTUuMzEwNCA1Ljk5OTQ1IDE4LjAwMDQgOC42ODk0NSAxOC4wMDA0IDExLjk5OTVDMTguMDAwNCAxNS4zMDk1IDE1LjMxMDQgMTcuOTk5NSAxMi4wMDA0IDE3Ljk5OTVaIiBmaWxsPSJibGFjayIvPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwXzI0MDJfMjM1NDAiPgo8cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IndoaXRlIi8+CjwvY2xpcFBhdGg+CjwvZGVmcz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Brightness6 = createIcon('Brightness6', [
  ['g', { clipPath: 'url(#clip0_2402_23540)', key: '1ur9kw' }],
  ['defs', { key: '9ahrjx' }],
]);

export default Brightness6;
